import { useMemo } from "react";
import api from "@/lib/api";
import { log } from "@/lib/log";

const ROLE_TABLE = { create: ["admin", "reviewer"], edit: ["admin", "reviewer"], delete: ["admin"], admin: ["admin"] };

// Session mutations (login/register/logout/switch) — the backend sets the httpOnly cookie; we just reload /auth/me.
export function useAuthActions({ loadMe, clear, setActiveWorkspaceId }) {
  return useMemo(() => ({
    login: async (email, password) => { await api.post("/auth/login", { email, password }); await loadMe(); },
    register: async (payload) => { await api.post("/auth/register", payload); await loadMe(); },
    logout: async () => {
      try { await api.post("/auth/logout"); } catch (e) { log.warn("Logout request failed (session may already be gone):", e?.response?.status || e?.message); }
      clear();
    },
    switchWorkspace: async (wid) => { await api.post(`/auth/switch/${wid}`); setActiveWorkspaceId(wid); await loadMe(); },
  }), [loadMe, clear, setActiveWorkspaceId]);
}

export const canWithRole = (role) => (action) => (ROLE_TABLE[action] || []).includes(role);
